export default {
  h1: {
    fontWeight: 600,
    fontSize: 55,
    lineHeight: "66px",
    fontFamily: "'Cinzel', serif",
    "@media(max-width:767px)": {
      fontSize: "34px !important",
      lineHeight: "42px",
    },
  },
  h2: {
    fontWeight: 500,
    fontSize: 35,
    lineHeight: "30px",
    fontFamily: "'Cinzel', serif",
    wordBreak: "break-word",
    "@media(max-width:767px)": {
      fontSize: "25px !important",
      lineHeight: "30px !important",
    },
  },
  h3: {
    fontWeight: 500,
    fontSize: 28,
    lineHeight: "40px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 25,
    lineHeight: "30px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h5: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: "30px",
    fontFamily: "'Cinzel', serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "24px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      lineHeight: "22px",
      fontSize: "14px !important",
    },
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Saira', sans-serif",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Saira', sans-serif",
  },
  body2: {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: "21px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "12px",
      lineHeight: "22px",
    },
  },
  body1: {
    fontWeight: 300,
    lineHeight: "21px",
    fontSize: 12,
    fontFamily: "'Cinzel', serif",
  },
};
